import {StyleSheet} from 'react-native';

import {darkGray} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  sourceStyle: {
    color: darkGray,
  },
});
